export interface HeaderFreezeModel {
  id: string;
  name: string;
  key?: string;
  checked?: boolean;
  disabled?: boolean;

}

export const FreezeColumn = {
  id: 'freezeBox',
  name: 'Freeze first column',
  key: 'freezeBox',
  checked: false,
  disabled: false
};
